export const injectScript = (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error(`[MF] Failed to load script: ${url}`));
    document.head.appendChild(script);
  });
};

export const loadScript = async <T>(
  globalName: string,
  url: string,
): Promise<T> => {
  await injectScript(url);

  const container = (globalThis as unknown as Record<string, unknown>)[
    globalName
  ] as T | undefined;
  if (!container) {
    throw new Error(
      `[MF] Global "${globalName}" not found after loading ${url}`,
    );
  }
  return container;
};

export const loadChunkMap = async (
  chunkBaseUrl: string,
): Promise<Record<string, string>> => {
  const g = globalThis as unknown as Record<string, unknown>;

  delete g.__CHUNK_MAP__;

  try {
    await injectScript(`${chunkBaseUrl}chunk-map.js?t=${Date.now()}`);

    const map = (g.__CHUNK_MAP__ as Record<string, string>) ?? {};
    return map;
  } catch (error) {
    throw new Error(
      `[MF] Failed to load chunk-map.js from ${chunkBaseUrl}: ${
        error instanceof Error ? error.message : String(error)
      }`,
    );
  } finally {
    delete g.__CHUNK_MAP__;
  }
};
